module.exports = __webpack_public_path__ + "static/media/scott85.a7042154.png";